import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  makeStyles,
  Grid,
  Typography,
} from '@material-ui/core'
import { Alert, AlertTitle } from '@material-ui/lab'
import {
  Route,
  Routes,
  Link,
} from 'react-router-dom'
import Page from 'src/components/Page'
import { getUserState } from '../../app/slices/userSlice'
import Form from './ScholarshipForm'

const useStyle = makeStyles(() => ({
  root: {
    padding: 10,
  },
  title: {
    marginBottom: 15,
  },
  icon: {
    marginRight: 10,
  },
}))

export const ScholarshipUser = () => {
  const classes = useStyle()
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user)
  const userStates = useSelector((state) => state.common.userStates)

  useEffect(() => {
    if (!user.state) {
      dispatch(getUserState())
    }
  }, [])
  // }, [user])

  const pageTitle = 'درخواست بورسیه'

  let pageContent = null
  if (!user?.profile?.isCompleted) {
    pageContent = (
      <Alert severity="warning">
        <AlertTitle>توجه</AlertTitle>
        ابتدا
        <Link to="/app/profile/edit"> پروفایل خود را تکمیل کنید</Link>
      </Alert>
    )
  } else if (user?.userState !== userStates.EXAM_RESULT_IS_READY) {
    pageContent = (
      <Alert severity="warning">
        <AlertTitle>توجه</AlertTitle>
        بعد از مشخص شدن نتیجه آزمون
        می توانید درخواست بورسیه بدهید
      </Alert>
    )
  } else {
    pageContent = (
      <Routes>
        <Route path="/" element={<Form />} />
      </Routes>
    )
  }

  return (
    <Page
      className={classes.root}
      title={pageTitle}
    >
      <Grid className={classes.root}>
        <Grid container justify="space-between" className={classes.title}>
          <Typography variant="h2" component="h2">{pageTitle}</Typography>
        </Grid>

        {pageContent}
      </Grid>
    </Page>

  )
}

export default ScholarshipUser
